enum ROUTES {
  EXCHANGE = '/exchange',
  MARGINS = '/exchange/margins',
  MARGINS_CURRENCY = '/exchange/margins/:currency',
  MARGIN_INFO = '/exchange/margins/:currency/:marginId',
  RATES = '/exchange/rates',
  RATES_CURRENCY = '/exchange/rates/:currency',
  RATES_ADD = '/exchange/rates/:currency/create',
  RATE_INFO = '/exchange/rates/:currency/:rateId',
  AUTO_SETTINGS = '/exchange/auto-settings',
  AUTO_SETTINGS_CURRENCY = '/exchange/auto-settings/:currency',
  AUTO_SETTINGS_GENERAL = '/exchange/auto-settings/:currency/general',
  AUTO_SETTINGS_ADD = '/exchange/auto-settings/:currency/add',
  AUTO_SETTINGS_EDIT = '/exchange/auto-settings/:currency/:settingId',
  RATE_REQUEST = '/exchange/rate-request',
  RATE_REQUEST_CURRENCY = '/exchange/rate-request/:currency',
  RATE_REQUEST_GENERAL = '/exchange/rate-request/:currency/general',
  RATE_REQUEST_ADD = '/exchange/rate-request/:currency/add',
  RATE_REQUEST_EDIT = '/exchange/rate-request/:currency/:rateId',
}

export default ROUTES;
